export enum CodigoUbicacion{
    fiscal = 0,
    entregaProducto = 1,
    entregaFactura = 2,
    entregaProductoFactura = 3,
    fiscalEntregaProductoFactura = 4
}
